/**
 * Backend unreadCounts yanıtını roomId -> sayı haritasına çevirir.
 * Desteklenen şekiller:
 * - { data: [ { messageRoomId|roomId|id, unreadCount|count|unreadMessagesCount }, ... ] }
 * - { data: { "room-guid": 3, ... } }
 */
export function normalizeUnreadCountsByRoomId(apiPayload) {
  const raw = apiPayload?.data !== undefined ? apiPayload.data : apiPayload;
  const out = {};

  if (!raw) return out;

  if (Array.isArray(raw)) {
    raw.forEach((row) => {
      if (!row || typeof row !== "object") return;
      const id =
        row.messageRoomId ?? row.roomId ?? row.id ?? row.messageRoomID;
      const n =
        row.unreadCount ??
        row.count ??
        row.unreadMessagesCount ??
        row.unread ??
        0;
      if (id != null && id !== "") {
        const num = Number(n);
        out[String(id)] = Number.isFinite(num) && num > 0 ? num : 0;
      }
    });
    return out;
  }

  if (typeof raw === "object") {
    Object.entries(raw).forEach(([k, v]) => {
      const num = Number(v);
      out[String(k)] = Number.isFinite(num) && num > 0 ? num : 0;
    });
  }

  return out;
}

/** Oda nesnesinde backend'in gömebileceği alanlar */
export function getUnreadCountForRoom(room, unreadMap) {
  if (!room?.id) return 0;
  const fromMap = unreadMap?.[String(room.id)];
  if (typeof fromMap === "number" && fromMap > 0) return fromMap;
  const embedded =
    room.unreadCount ??
    room.unreadMessagesCount ??
    room.unreadMessageCount ??
    room.unreadMessages ??
    room.unread;
  const n = Number(embedded);
  return Number.isFinite(n) && n > 0 ? n : 0;
}

/**
 * GET .../unreadTotal yanıtı: düz sayı, { isSuccess, data }, { Data, IsSuccess } vb.
 * @returns {number|null} sayı veya parse edilemediyse null (önceki değer korunur)
 */
export function parseUnreadTotalPayload(raw) {
  if (raw == null) return null;
  if (typeof raw === "number" && Number.isFinite(raw)) return raw;
  if (typeof raw === "string" && raw.trim() !== "") {
    const n = Number(raw);
    return Number.isFinite(n) ? n : null;
  }
  if (typeof raw === "object") {
    const success = raw.isSuccess ?? raw.IsSuccess;
    const inner = raw.data ?? raw.Data;
    if (success === true && inner != null) {
      const n = Number(inner);
      return Number.isFinite(n) ? n : null;
    }
    if (inner != null && success !== false) {
      const n = Number(inner);
      if (Number.isFinite(n)) return n;
    }
  }
  return null;
}
